import React from 'react';
import { Grid, Image, Header, Segment } from 'semantic-ui-react';
import LoadingScreen from '../common/LoadingScreen';
import { MAINCOLUMNS } from '../globals';

const LoginLayout = (props) => {
  if (props.loading) {
      return <LoadingScreen />
  }

  return (
      <Grid className="fullheight fullwidth loginpage" padded centered verticalAlign="middle">
          <Grid.Row>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column {...MAINCOLUMNS} textAlign="center">
                <Image src="/logo.jpeg" />
                <Grid centered>
                  <Grid.Column width={5} textAlign="center">
                    <Header as="h3" inverted>by</Header><Image as="a" href="https://www.zenztech.com" fluid src="/logo_zenz.png" />
                    <br/><br/>
                  </Grid.Column>
                </Grid>
                {props.children}
            </Grid.Column>        
          </Grid.Row>
          <Grid.Row>
          </Grid.Row>
      </Grid>
  )
}

export default LoginLayout


// WEBPACK FOOTER //
// ./src/common/LoginLayout.js